import type { LegalBlock, LegalInline, LegalList, LegalSubheading, LegalText } from "./types";

const TOKEN = /\*\*([^*]+)\*\*|\[([^\]]+)\]\(([^)\s]+)\)/g;

const isExternal = (href: string): boolean => /^https?:\/\//.test(href);

const tokenOf = (match: RegExpExecArray): LegalInline => {
  const [, strong, label = "", href = ""] = match;
  if (strong !== undefined) {
    return { kind: "strong", text: strong };
  }
  return { kind: "link", text: label, href, external: isExternal(href) };
};

export const parseLegalText = (text: LegalText): LegalInline[] => {
  const parts: LegalInline[] = [];
  let last = 0;
  for (const match of text.matchAll(TOKEN)) {
    if (match.index > last) {
      parts.push({ kind: "text", text: text.slice(last, match.index) });
    }
    parts.push(tokenOf(match));
    last = match.index + match[0].length;
  }
  if (last < text.length) {
    parts.push({ kind: "text", text: text.slice(last) });
  }
  return parts;
};

export const legalPlainText = (text: LegalText): string =>
  parseLegalText(text)
    .map((part) => part.text)
    .join("");

export const legalLink = (label: string, href: string): LegalText => `[${label}](${href})`;

export const legalEmailLink = (address: string): LegalText => legalLink(address, `mailto:${address}`);

export const isLegalList = (block: LegalBlock): block is LegalList => typeof block !== "string" && "list" in block;

export const isLegalSubheading = (block: LegalBlock): block is LegalSubheading => typeof block !== "string" && "subheading" in block;
